// extracted by css-extract-rspack-plugin
export default {"container":"SuspenseFallback-module__container__rgyZT","placeholder":"SuspenseFallback-module__placeholder__OKPvB"};